import { render, staticRenderFns } from "./AmetrasSwitchTemplate.vue?vue&type=template&id=e4985c36&scoped=true&"
import script from "./AmetrasSwitchTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasSwitchTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasSwitchTemplate.vue?vue&type=style&index=0&id=e4985c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4985c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
